import type { ProfitMarginInput } from "@/services/Market.service";

export function formatMargin(input: ProfitMarginInput): string {
  const value = input.marginValue || "0";
  return input.marginType === "FLAT" ? `₦${value} per $1` : `${value}%`;
}
